module.exports = __webpack_public_path__ + "img/template-upload-search-location.860a9837.png";